exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".all-question .question-list[data-v-65df41c7]{margin:10px 0}.all-question .question-list .question-list-item[data-v-65df41c7]{padding:10px;background-color:#fff}.all-question .question-list .question-list-item[data-v-65df41c7] .title img{max-width:100%;height:auto!important}.all-question .question-list .image-multiple-question[data-v-65df41c7],.all-question .question-list .image-single-question[data-v-65df41c7]{background-color:#f7f7f7!important}", ""]);

// exports
